import { createContext, useContext } from 'react'

export const DiscountContext = createContext({})

export const useDiscountContext = () => {
  const value = useContext(DiscountContext)
  return {
    ...value,
  }
}
